import { api } from "../utils/AuthManager";
const PostGroup = async (data) => {
  return api
    .post(`/api/group/`, data)

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default PostGroup;
